import { createReducer } from 'redux-starter-kit';

import { UiReducerType } from './ui.types';
import { SET_TOGGLE_MENU } from './ui.actions';

export const initialState: UiReducerType = {
  isMenuOpen: true,
};

export default createReducer(initialState, {
  [SET_TOGGLE_MENU]: (state, action) => {
    state.isMenuOpen = action.payload;
  },
});
